import { render } from "./LoadingPage.vue?vue&type=template&id=38217fce&scoped=true"
const script = {}

import "./LoadingPage.vue?vue&type=style&index=0&id=38217fce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38217fce"]])

export default __exports__